// extracted by mini-css-extract-plugin
module.exports = {"page":"page-module__page___2kLvZ","wrap":"page-module__wrap___iB9Gk","content":"page-module__content___nnD59"};